export const getRandomCoordinate = (min, max) => {
  const rand = min + Math.random() * (max - min);
  return Math.round(rand);
};

export const createCircleStyle = ({
  blur = '8px',
  background,
  x,
  y,
  animation,
  duration,
  easing,
}) => {
  const keyframes = {
    [`@keyframes ${animation}`]: {
      '25%': {
        transform: `translate(${getRandomCoordinate(
          -50,
          150,
        )}px, ${getRandomCoordinate(-30, 40)}px)`,
      },
      '50%': {
        transform: `translate(${getRandomCoordinate(
          -50,
          150,
        )}px, ${getRandomCoordinate(0, 40)}px)`,
      },

      '75%': {
        transform: `translate(${getRandomCoordinate(
          -50,
          150,
        )}px, ${getRandomCoordinate(20, 40)}px)`,
      },
    },
  };

  return {
    ...keyframes,
    width: '18px',
    height: '18px',
    backgroundColor: background,
    position: 'absolute',
    display: 'inline-block',
    left: 0,
    filter: `blur(${blur})`,
    transform: `translate(${x}%, ${y}%)`,
    animation: `${animation} ${duration} ${easing} infinite`,
  };
};

const styles = {
  main: {
    display: 'inline-block',
    padding: {
      xl: '8px 16px',
      sm: '6px 12px',
      xs: '4px 8px',
    },
    borderRadius: '4px',
    overflow: 'hidden',
    webkitOverflow: 'hidden',
    position: 'relative',
    minWidth: '77px',
  },
  animationBlock: {
    maskImage: '-webkit-radial-gradient(#fff,#000)',
    webkitMaskImage: '-webkit-radial-gradient(#fff,#000)',
    backgroundColor: 'kit.background.white',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    overflow: 'hidden',
    webkitOverflow: 'hidden',
    borderRadius: '4px',
  },
  content: {
    fontFamily: 'RF Rostin',
    position: 'relative',
    fontWeight: '700',
    fontSize: {
      xs: '12px',
      lg: '14px',
    },
    lineHeight: '120%',
    letterSpacing: '-0.01em',
    textTransform: 'uppercase',
    color: 'kit.text.h',
  },
};

export default styles;
